export default "__VITE_ASSET__abv3UuOA__"